import { RedirectUrlOriginTypes } from "@enums/redirect-url-origin-types"
import Badge from "react-bootstrap/Badge";

type RedirectUrlOriginBadgeProps = {
    redirectUrlOrigin: RedirectUrlOriginTypes;
}

export const RedirectUrlOriginBadge = ({ redirectUrlOrigin }: RedirectUrlOriginBadgeProps) => {
    return (<div>
        <Badge bg={redirectUrlOrigin === RedirectUrlOriginTypes.CALLBACK_URL ? "danger" : "success"}>
            {redirectUrlOrigin}
        </Badge>
    </div>);
}